module.exports = __webpack_public_path__ + "f97fdc4a4c27bf306596c456729b4e14.svg";